export const copyToClipboard = (text: string) => {
  // https://stackoverflow.com/questions/49618618/copy-current-url-to-clipboard
  const dummy = document.createElement('input');
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
};
